<ng-container *ngIf="value && dataInfo">
    <div [ngClass]="dataInfo.action">
        <div class="block">
            <div class="title">{{getResourceKeyCaption() | translate}}</div>
            <div *ngIf="bookingSlotChangeReasonItem">
                <entity-selector class="selector-reason" [(ngModel)]="bookingSlotChangeReasonItem.slotChangeReasonId"
                    [entitySelector]="'SlotChangeReason'"
                    placeholder="{{'SHARED.SLOTCHANGEREASONMANAGE.SLOTCHANGEREASONID' | translate}}"
                    name="slotChangeReasonId" [fixedFilterKeys]="SLOTCHANGEREASON_FILTERKEYS" [readonly]="readonly"
                    (valuechangefunction)="slotChangeReasonChangedEvent($event)">
                </entity-selector>

                <textarea-component class="textarea" [readonly]="readonly"
                    [(ngModel)]="bookingSlotChangeReasonItem.comment" name="comment"
                    (ngModelChange)="changeComment($event)" placeholder="{{getResourceKeyComments() | translate}}">
                </textarea-component>

                <button (click)="doPreAction($event)" [disabled]="disabledButton"
                    class="button action right">{{getResourceButton() |
                    translate}}</button>
            </div>
        </div>

        <div class="block">
            <div class="subtitle line">{{'SHARED.SLOTCHANGEREASONMANAGE.RULES.CAPTION' | translate}}</div>
            <div *ngIf="value" class="line help"
                [innerHTML]="'SHARED.SLOTCHANGEREASONMANAGE.RULES.HELP' | translate">
            </div>
        </div>
    </div>
</ng-container>